<template>
    <div class="bg-dashboard">
        <nav class="navbar navbar-expand-lg navbar-light bg-white navbar-shadow">
            <div class="container-fluid">
                <router-link :to="{name: 'dashboard'}" href="#"><img alt="Logo Modular" src="../assets/img/logo-rsca.png" height="40px"></router-link>
                <button aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"
                        class="navbar-toggler"
                        data-target="#navbarSupportedContent" data-toggle="collapse" type="button">
                    <span class="navbar-toggler-icon"></span>
                </button>

                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul class="navbar-nav ml-auto">
                        <li class="nav-item dropdown">
                            <a aria-expanded="false" aria-haspopup="true" class="nav-link dropdown-toggle"
                               data-toggle="dropdown"
                               href="#" id="navbarDropdown" role="button">{{(USER) ? USER.user.name : ''}}</a>
                            <!-- Here's the magic. Add the .animate and .slide-in classes to your .dropdown-menu and you're all set! -->
                            <div aria-labelledby="navbarDropdown"
                                 class="dropdown-menu dropdown-menu-right animate slideIn">
                                <router-link :to="{name: 'dashboard'}" class="dropdown-item" href="#">Dashboard
                                </router-link>
                                <router-link :to="{name: 'userIndex'}" class="dropdown-item" href="#"
                                             v-if="ROLES === 'admin'">Gebruikers
                                </router-link>
                                <router-link :to="{name: 'appIndex'}" class="dropdown-item" href="#"
                                             v-if="ROLES === 'admin'">Apps
                                </router-link>
                                <div class="dropdown-divider"></div>
                                <a @click="logout" class="dropdown-item" href="#">Afmelden</a>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
        <router-view></router-view>
    </div>
</template>
<script>
    import {mapGetters} from 'vuex'

    export default {
        name: 'layout',
        computed: {
            ...mapGetters([
                'USER',
                'ROLES'
            ])
        },
        created(){
            this.$store.dispatch('userData')
        },
        methods: {
            async logout() {
                await this.$store.dispatch('destroyToken')
            },
        }
    }
</script>
<style scoped>
    .bg-dashboard {
        background: #ffe0f1;
        height: 100vh;
        min-height: 100vh;
    }
    .bg-dashboard > .container-fluid{
        background: #ffe0f1;
    }

    .navbar-shadow {
        box-shadow: 0 0.1rem 0.3rem 0 rgba(0, 0, 0, 0.1)
    }
</style>
